export const colors = [
  '#A50050',
  '#7FA9AE',
  '#007398',
  '#002F6C',
  '#FAC93D',
  '#ED8B00',
  '#B1B3B3',
  '#565A5C',
  '#db99b9',
  '#cbdcde',
  '#99c7d5',
  '#99abc4',
  '#fde9b1',
  '#f7d099',
  '#dfe0e0',
  '#bbbdbd',
];

export const grayTextBackgrounds = [
  '#FAC93D',
  '#db99b9',
  '#cbdcde',
  '#99c7d5',
  '#99abc4',
  '#fde9b1',
  '#f7d099',
  '#dfe0e0',
  '#bbbdbd',
];

export const textColors = ['#FFFFFF', '#002F6C'];
